import { ComponentSize } from '../../../typings/design-tokens';

export function getSkeletonSize(size: ComponentSize = 'medium') {
  const skeletonSizeMap: { [key: string]: any } = {
    xsmall: {
      icon: {
        flexSize: '1 0',
        size: ['23px', '28px', '28px'],
        fontSize: '14',
        fontWidth: ['50px', '40px'],
        spaceBottom: ['5px', '7px'],
      },
      label: {
        flexSize: ['1 0', '2 0', '2 0'],
        fontSize: '18--22',
        width: ['80px', '60px', '60px'],
      },
    },
    small: {
      icon: {
        flexSize: '1 0',
        size: ['23px', '28px', '28px'],
        fontSize: '14',
        fontWidth: ['50px', '40px'],
        spaceBottom: ['5px', '7px'],
      },
      label: {
        flexSize: ['1 0', '2 0', '2 0'],
        fontSize: '18--22',
        width: ['80px', '60px', '60px'],
      },
    },
    /*
		small: {
      icon: {
        flexSize: '1 0',
        size: '25px',
        fontSize: '14',
        fontWidth: '60px',
        spaceBottom: '5px',
      },
      label: {
        flexSize: ['1 0', '2 0', '2 0'],
        fontSize: '18--22',
        width: '70px',
      },
    },
		*/
    medium: {
      icon: {
        flexSize: '1 0',
        size: ['28px', '40px', '40px'],
        fontSize: '16',
        fontWidth: ['65px', '80px'],
        spaceBottom: ['13px', '10px'],
      },
      label: {
        flexSize: ['1 0', '2 0', '2 0'],
        fontSize: '24--32',
        width: '80px',
      },
    },
  };

  return skeletonSizeMap[size] ?? skeletonSizeMap.medium;
}
